import { dialog } from "../../../nq-component";
import React, { useState } from "react";

function DialogDate({ onchange, handleConfirm }) {
  const [date, setDate] = useState(null);
  console.log(date);
  return (
    <>
      <div className="p-4">
        <div className="d-flex flex-column">
          <div className="d-flex gap-3">
            <i
              class="bi bi-calendar-event fs-2 px-2 py-1 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5
              className="fw-bold align-self-center"
              style={{ color: "#D18237" }}
            >
              Date
            </h5>
          </div>
          <div className="d-flex flex-column mx-5">
            <div className="d-flex flex-column mt-3 w-100">
              <label>
                <b>Start Date</b>
                <span className="text-danger fw-lighter ms-1">*</span>
              </label>
              <div className="ms-2 me-1">
                <input
                  type="date"
                  className="w-100 rounded-1 p-2"
                  min={new Date().toISOString().split("T")[0]}
                  // rows="3"
                  onChange={(e) => {
                    onchange(e);
                    setDate(e.target.value);
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${Math.min(
                      e.target.scrollHeight,
                      150
                    )}px`;
                  }}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mb-3 d-flex justify-content-center gap-2">
        <button
          className="btn text-white px-5"
          onClick={handleConfirm}
          style={{
            backgroundColor:
              date === null || date === "" ? "#d1823775" : "#D18237",
          }}
          disabled={date === null || date === ""}
        >
          Confirm
        </button>
        <button
          className="btn px-5"
          style={{ backgroundColor: "#e8ecf3" }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
      </div>
    </>
  );
}

export default DialogDate;
